import { render, staticRenderFns } from "./History.vue?vue&type=template&id=30c4fa95&scoped=true&"
import script from "./History.vue?vue&type=script&lang=ts&"
export * from "./History.vue?vue&type=script&lang=ts&"
import style0 from "./History.vue?vue&type=style&index=0&id=30c4fa95&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c4fa95",
  null
  
)

export default component.exports